import React, {memo, useRef, useState} from "react";
import {Tooltip} from "antd";
import {useClickOutside} from "hooks";
import InfoButton from "images/objectPanel/btn_more.svg";
import useAddAssetToScene from "../hooks/useAddAssetToScene";
import useHandleAssetInfo from "../hooks/useHandleAssetInfo";
import useDragAndDropAsset from "../hooks/useDragAndDropAsset";
import AssetItemInfoPopup from "../AssetItemInfoPopup";
import styles from "./index.module.scss";

function AssetItemInfo({data, children}) {
  const [isInfoOpen, setInfoOpen] = useState(false);
  const clickOutsideRef = useRef();
  const {onClickAsset} = useAddAssetToScene();
  const {onClickEditBtn} = useHandleAssetInfo();
  const {handleDragAssetStartToScene} = useDragAndDropAsset();

  const exceptRef = useRef();

  const handleInfoOpen = () => {
    setInfoOpen(!isInfoOpen);
  };
  const handleClickEdit = data => {
    onClickEditBtn(data);
    setInfoOpen(false);
  };

  const handleDragToScene = e => {
    handleDragAssetStartToScene(e, {
      name: data.name,
      url: data.url,
      topCategory: data.topCategory,
      midCategory: data.midCategory,
      subCategory: data.subCategory,
      duration: data?.duration,
    });
  };

  useClickOutside(clickOutsideRef, () => setInfoOpen(false), exceptRef);

  return (
    <div className={styles.container} draggable onDragStart={handleDragToScene}>
      <div className={styles.asset_item_wrapper} onClick={() => onClickAsset(data)}>
        {children}
      </div>

      <Tooltip
        overlayInnerStyle={{backgroundColor: "transparent", boxShadow: "none"}}
        open={isInfoOpen}
        placement="bottomRight"
        title={
          <div ref={clickOutsideRef}>
            <AssetItemInfoPopup onClickEdit={handleClickEdit} id={data.id} />
          </div>
        }
      >
        <button className={styles.button} onClick={handleInfoOpen} ref={exceptRef}>
          <img src={InfoButton} alt="info_button" />
        </button>
      </Tooltip>
    </div>
  );
}

export default memo(AssetItemInfo);
